import { useQuery } from 'react-query';
import http from '../config/http-service';
import type { MasterProductListResponse } from './types';

// GET ums/v1/cms/master-products — scoped to one family's variants (used by
// the family Variants modal and the inquiry item grid's variant elimination).
// Not URL-page-params-driven: neither consumer is a page-level list, so it
// must not share ?page/?sort state with the family list screen. Variants per
// family are expected to be few, so a fixed limit stands in for pagination.
export const masterProductsEndpoint = 'ums/v1/cms/master-products';

export const useGetMasterProductsApi = (familyId: number | undefined, options: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: [masterProductsEndpoint, familyId],
    queryFn: async (): Promise<MasterProductListResponse> => {
      const { data } = await http.get(masterProductsEndpoint, {
        params: { familyId, page: 1, limit: 100 },
      });
      return data;
    },
    enabled: (options.enabled ?? true) && !!familyId,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
  });
};
